import React from 'react';
import { motion } from 'framer-motion';

export const EmptyState = ({ title, description, action, image }) => {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} data-testid="empty-state" className="flex flex-col items-center text-center py-10 px-6">
      <div className="relative w-44 h-44 sm:w-56 sm:h-56 rounded-3xl overflow-hidden border border-border shadow-[0_18px_50px_-22px_rgba(15,23,42,0.35)] mb-5">
        <img src={image || 'https://images.unsplash.com/photo-1606667847618-e00fd659eb5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=600'} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent" />
      </div>
      <h3 className="font-serif text-2xl font-semibold mb-1">{title}</h3>
      {description && <p className="text-sm text-muted-foreground max-w-sm">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </motion.div>
  );
};
